<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Link({
              label: 'FAQ link',
              modelPath: [this, 'form', 'faq_link'],
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
